import Layout from "../Layout";
import HeaderCustomer from "./HeaderCustomer";
import ListCustomer from "./ListCustomer";

const Customers = () => (
  <Layout>
    <HeaderCustomer />
    <ListCustomer />
  </Layout>
);

export default Customers;
